var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTapLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.557,
    height: 32,
    viewBox: "0 0 109.557 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.316,
    y1: 3.546,
    x2: -1.486,
    y2: 3.546,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc8621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fc811f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fd7419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fe5e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ff3f01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3c00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "m103.152 93.151-1.752-3.593a2.021 2.021 0 0 0-.88-.9 1.767 1.767 0 0 0-.876-.222h-.867a5.85 5.85 0 0 1-10.969 0h-.869a1.768 1.768 0 0 0-1.372.652 2.055 2.055 0 0 0-.33.483l-1.753 3.592a2.02 2.02 0 0 0 3.632 1.766l.359-.739h11.687l.361.739a2.018 2.018 0 0 0 3.629-1.766zm-9.832-2.739a3.946 3.946 0 1 0-3.95-3.945 3.949 3.949 0 0 0 3.95 3.945m.668 21.722a2.017 2.017 0 0 1 2.139-1.889l.82.049 5.744-10.159-.466-.667a2.021 2.021 0 0 1 3.331-2.291l2.273 3.29a2.076 2.076 0 0 1 .258.523 1.757 1.757 0 0 1-.107 1.515l-.426.754a5.837 5.837 0 0 0-5.392 9.536l-.434.752a1.768 1.768 0 0 1-.633.647 2.008 2.008 0 0 1-1.221.323l-3.995-.242a2.019 2.019 0 0 1-1.894-2.133zm9.117-5.065a3.949 3.949 0 1 0 5.383-1.495 3.941 3.941 0 0 0-5.383 1.495m-21.884-9.81-2.228 3.326a2 2 0 0 0-.334 1.215 1.777 1.777 0 0 0 .243.872l.446.747a5.838 5.838 0 0 1 5.546 9.447l.446.747a1.769 1.769 0 0 0 1.259.852 2.009 2.009 0 0 0 .582.04l3.993-.307a2.016 2.016 0 1 0-.321-4.02l-.82.062-5.913-10.065.446-.683a2.018 2.018 0 0 0-3.366-2.224zm2.611 9.85a3.949 3.949 0 1 0-1.41 5.4 3.954 3.954 0 0 0 1.41-5.4",
    transform: "translate(-76.475 -82.52)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#0a2540}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "tap-logo_1_",
    "data-name": "tap-logo (1)",
    transform: "translate(-32.825 -20.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(32.825 20.18)",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "m0 0 45.821-.013-.012 40.829-45.821.013z",
    transform: "rotate(79.34 19.109 17.534)",
    style: {
      fill: "url(#linear-gradient)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210",
    transform: "translate(72.813 20.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-3",
    d: "M266.37 85v1.384h-2.852v7.488h-1.582v-7.5h-2.856V85z",
    transform: "translate(-258.561 -85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-3",
    d: "M296.552 93.865h-1.482V85h1.482v3.07a2.426 2.426 0 0 1 .8-.606 2.355 2.355 0 0 1 .994-.209 2.052 2.052 0 0 1 1.589.642 2.409 2.409 0 0 1 .586 1.7v4.273h-1.482v-3.848a1.6 1.6 0 0 0-.29-1.025 1.029 1.029 0 0 0-.847-.359 1.286 1.286 0 0 0-.958.4 1.4 1.4 0 0 0-.39 1.025z",
    transform: "translate(-286.532 -85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-3",
    d: "M327.087 101.827a3.237 3.237 0 0 1-1.286-.254 2.974 2.974 0 0 1-1.025-.722 3.159 3.159 0 0 1-.624-1.069 3.944 3.944 0 0 1-.223-1.337 3.849 3.849 0 0 1 .223-1.292 3.273 3.273 0 0 1 .61-1.067 2.9 2.9 0 0 1 1.014-.753 3.01 3.01 0 0 1 1.248-.261 2.654 2.654 0 0 1 2.1.891 3.379 3.379 0 0 1 .778 2.315v.495h-4.547a2.157 2.157 0 0 0 .55 1.31 1.56 1.56 0 0 0 1.181.481 1.622 1.622 0 0 0 .956-.279 1.375 1.375 0 0 0 .55-.76l1.272.483a2.805 2.805 0 0 1-1.081 1.337 3.014 3.014 0 0 1-1.696.482zm-.076-5.5a1.517 1.517 0 0 0-1 .345 1.822 1.822 0 0 0-.575.989h2.97a1.337 1.337 0 0 0-.383-.969 1.381 1.381 0 0 0-1.012-.364z",
    transform: "translate(-308.962 -92.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-3",
    d: "m256.75 143.132 3.36-8.872h1.782l3.38 8.872h-1.6l-.772-2.032h-3.83l-.755 2.028zm5.626-3.411-1.408-3.705-1.384 3.705z",
    transform: "translate(-256.75 -123.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-3",
    d: "M300.756 145.78a1.2 1.2 0 0 0-.914.4 1.433 1.433 0 0 0-.37 1.025v3.805H298v-6.479h1.484v.693a2.132 2.132 0 0 1 .784-.61 2.382 2.382 0 0 1 .994-.2 2.1 2.1 0 0 1 .994.223 1.869 1.869 0 0 1 .724.668 2.9 2.9 0 0 1 .931-.68 2.625 2.625 0 0 1 1.083-.223 2.09 2.09 0 0 1 1.593.642 2.375 2.375 0 0 1 .606 1.693V151h-1.484v-3.841a1.626 1.626 0 0 0-.279-1.032.969.969 0 0 0-.809-.352 1.2 1.2 0 0 0-.913.4 1.433 1.433 0 0 0-.37 1.025v3.805h-1.484v-3.843a1.626 1.626 0 0 0-.29-1.032.969.969 0 0 0-.809-.352z",
    transform: "translate(-288.809 -131.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-3",
    d: "M350.955 142.223a2.547 2.547 0 0 1-.934.771 2.707 2.707 0 0 1-1.2.267 2.575 2.575 0 0 1-1.056-.212 2.2 2.2 0 0 1-.811-.6v.68h-1.484v-8.869h1.482v3.077a2.228 2.228 0 0 1 .811-.606 2.576 2.576 0 0 1 1.056-.209 2.736 2.736 0 0 1 1.2.265 2.553 2.553 0 0 1 .934.773 3.414 3.414 0 0 1 .533 1.056 4.514 4.514 0 0 1 0 2.558 3.414 3.414 0 0 1-.531 1.049zm-2.433-4.411a1.462 1.462 0 0 0-1.167.512 2.045 2.045 0 0 0-.446 1.379v.381a2.005 2.005 0 0 0 .446 1.366 1.591 1.591 0 0 0 2.377-.042 2.85 2.85 0 0 0 0-3.039 1.459 1.459 0 0 0-1.21-.55z",
    transform: "translate(-325.703 -123.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-3",
    d: "M381.558 146.281v3.213c0 .305 0 .588.025.853s.04.5.074.7h-1.447c0-.082-.016-.167-.025-.254a2.613 2.613 0 0 1 0-.265 2.137 2.137 0 0 1-.791.468 3.246 3.246 0 0 1-1.052.16 2.3 2.3 0 0 1-1.56-.537 1.742 1.742 0 0 1-.617-1.377 1.709 1.709 0 0 1 .53-1.3 3.391 3.391 0 0 1 1.644-.735l1.782-.37v-.321a.691.691 0 0 0-.265-.6 1.782 1.782 0 0 0-1.651.025.831.831 0 0 0-.307.668h-1.446a2.03 2.03 0 0 1 .742-1.6 3.024 3.024 0 0 1 1.938-.561 2.891 2.891 0 0 1 1.782.481 1.6 1.6 0 0 1 .644 1.352zm-3 3.694a1.8 1.8 0 0 0 1.114-.334 1.043 1.043 0 0 0 .446-.876v-.791l-1.4.3a2.052 2.052 0 0 0-.851.345.708.708 0 0 0-.247.568.72.72 0 0 0 .252.582 1.043 1.043 0 0 0 .682.207z",
    transform: "translate(-349.559 -131.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-3",
    d: "M406.557 151.14a4.131 4.131 0 0 1-1.753-.372 2.869 2.869 0 0 1-1.223-1l1.114-.891a2.134 2.134 0 0 0 .8.76 2.165 2.165 0 0 0 1.074.29 1.615 1.615 0 0 0 .891-.209.668.668 0 0 0 .328-.593.517.517 0 0 0-.136-.377 1.065 1.065 0 0 0-.481-.243q-.074-.022-.314-.074l-.637-.136a9.5 9.5 0 0 1-.951-.241 2.368 2.368 0 0 1-.555-.254 1.535 1.535 0 0 1-.519-.568 1.682 1.682 0 0 1-.174-.789 1.814 1.814 0 0 1 .711-1.477 2.805 2.805 0 0 1 1.823-.575 3.6 3.6 0 0 1 1.544.334 2.487 2.487 0 0 1 1.074.891l-1 .891a2.005 2.005 0 0 0-1.7-.916 1.243 1.243 0 0 0-.729.192.6.6 0 0 0-.285.524.446.446 0 0 0 .118.323.992.992 0 0 0 .377.223l.241.062c.094.025.279.067.55.125.535.114.9.207 1.114.276a4.069 4.069 0 0 1 .544.223 1.588 1.588 0 0 1 .624.593 1.7 1.7 0 0 1 .2.853 1.891 1.891 0 0 1-.76 1.544 2.968 2.968 0 0 1-1.909.61z",
    transform: "translate(-370.866 -131.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-3",
    d: "M433.48 151.156a4.142 4.142 0 0 1-1.747-.377 2.87 2.87 0 0 1-1.223-1l1.114-.891a2.27 2.27 0 0 0 1.878 1.049 1.62 1.62 0 0 0 .891-.209.668.668 0 0 0 .328-.593.528.528 0 0 0-.136-.377 1.09 1.09 0 0 0-.483-.243q-.074-.022-.314-.074l-.637-.136a9.671 9.671 0 0 1-.951-.241 2.369 2.369 0 0 1-.555-.254 1.535 1.535 0 0 1-.519-.568 1.682 1.682 0 0 1-.174-.789 1.818 1.818 0 0 1 .693-1.468 2.805 2.805 0 0 1 1.823-.575 3.6 3.6 0 0 1 1.544.334 2.493 2.493 0 0 1 1.076.891l-1 .891a2.005 2.005 0 0 0-1.7-.916 1.243 1.243 0 0 0-.729.192.6.6 0 0 0-.272.512.446.446 0 0 0 .118.323.992.992 0 0 0 .377.223l.241.062c.1.025.279.067.55.125.535.114.9.207 1.114.276a3.953 3.953 0 0 1 .544.223 1.588 1.588 0 0 1 .624.593 1.7 1.7 0 0 1 .2.853 1.885 1.885 0 0 1-.762 1.562 2.966 2.966 0 0 1-1.913.602z",
    transform: "translate(-391.796 -131.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-3",
    d: "M463.969 146.281v3.213c0 .305 0 .588.025.853s.04.5.074.7h-1.446c0-.082-.016-.167-.025-.254a2.607 2.607 0 0 1-.011-.265 2.119 2.119 0 0 1-.791.468 3.246 3.246 0 0 1-1.052.16 2.3 2.3 0 0 1-1.56-.537 1.742 1.742 0 0 1-.617-1.377 1.709 1.709 0 0 1 .53-1.3 3.378 3.378 0 0 1 1.644-.735l1.782-.37v-.321a.691.691 0 0 0-.265-.6 1.782 1.782 0 0 0-1.651.025.831.831 0 0 0-.307.668h-1.446a2.03 2.03 0 0 1 .742-1.6 3.024 3.024 0 0 1 1.938-.561 2.891 2.891 0 0 1 1.782.481 1.6 1.6 0 0 1 .654 1.352zm-3 3.694a1.8 1.8 0 0 0 1.114-.334 1.043 1.043 0 0 0 .446-.876v-.791l-1.4.3a2.052 2.052 0 0 0-.851.345.784.784 0 0 0 0 1.15 1.034 1.034 0 0 0 .687.207z",
    transform: "translate(-413.6 -131.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-3",
    d: "M490.1 143.268a2.707 2.707 0 0 1-1.2-.267 2.529 2.529 0 0 1-.934-.771 3.414 3.414 0 0 1-.533-1.056 4.514 4.514 0 0 1 0-2.558 3.413 3.413 0 0 1 .533-1.056 2.535 2.535 0 0 1 .934-.773 2.736 2.736 0 0 1 1.2-.265 2.576 2.576 0 0 1 1.056.209 2.2 2.2 0 0 1 .809.606v-3.077h1.484v8.872h-1.484v-.686a2.17 2.17 0 0 1-.809.6 2.576 2.576 0 0 1-1.056.218zm1.9-3.177v-.381a2.057 2.057 0 0 0-.446-1.379 1.6 1.6 0 0 0-2.384.045 2.85 2.85 0 0 0 0 3.039 1.591 1.591 0 0 0 2.377.042 2.005 2.005 0 0 0 .452-1.366z",
    transform: "translate(-435.894 -123.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-3",
    d: "M525.173 145.4a2.969 2.969 0 0 1 .617 1.056 4.314 4.314 0 0 1 0 2.656 2.97 2.97 0 0 1-.617 1.056 2.919 2.919 0 0 1-1.02.735 3.342 3.342 0 0 1-2.556 0 2.9 2.9 0 0 1-1.02-.735 2.969 2.969 0 0 1-.617-1.056 4.314 4.314 0 0 1 0-2.656 2.969 2.969 0 0 1 .617-1.056 2.843 2.843 0 0 1 1.02-.735 3.342 3.342 0 0 1 2.556 0 2.863 2.863 0 0 1 1.02.735zm-2.3.256a1.426 1.426 0 0 0-1.192.568 2.979 2.979 0 0 0 0 3.119 1.531 1.531 0 0 0 2.384 0 2.979 2.979 0 0 0 0-3.119 1.424 1.424 0 0 0-1.191-.568z",
    transform: "translate(-461.153 -131.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-3",
    d: "M555.768 144.8h.2a1.028 1.028 0 0 1 .223.018v1.482a2.668 2.668 0 0 0-.272-.031h-.272a1.635 1.635 0 0 0-1.2.446 1.6 1.6 0 0 0-.446 1.192v3.411h-1.481v-6.472H554v.965a1.668 1.668 0 0 1 .7-.729 2.146 2.146 0 0 1 1.068-.282z",
    transform: "translate(-486.622 -131.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-3",
    d: "M265.551 189h-1.965v3.433H262v-8.883h3.547a3.565 3.565 0 0 1 2.371.711 2.806 2.806 0 0 1-.007 4.01 3.641 3.641 0 0 1-2.359.726zm-1.965-4.077v2.718h1.878a2.063 2.063 0 0 0 1.29-.352 1.361 1.361 0 0 0 0-2.021 2.088 2.088 0 0 0-1.3-.345z",
    transform: "translate(-260.83 -161.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-3",
    d: "M295.73 183.55h1.484v8.87h-1.484z",
    transform: "translate(-287.045 -161.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-3",
    d: "M312.429 195.6v3.213c0 .305 0 .588.025.851a6.939 6.939 0 0 0 .074.7h-1.446c0-.08-.016-.165-.024-.252a2.607 2.607 0 0 1-.011-.265 2.136 2.136 0 0 1-.791.468 3.246 3.246 0 0 1-1.052.16 2.3 2.3 0 0 1-1.56-.537 1.742 1.742 0 0 1-.617-1.377 1.709 1.709 0 0 1 .53-1.3 3.379 3.379 0 0 1 1.644-.735l1.782-.37v-.334a.693.693 0 0 0-.265-.6 1.4 1.4 0 0 0-.809-.189 1.372 1.372 0 0 0-.842.223.831.831 0 0 0-.307.668h-1.446a2.028 2.028 0 0 1 .742-1.6 3.024 3.024 0 0 1 1.938-.561 2.891 2.891 0 0 1 1.782.481 1.6 1.6 0 0 1 .653 1.356zm-3 3.685a1.8 1.8 0 0 0 1.114-.334 1.043 1.043 0 0 0 .446-.876v-.791l-1.4.3a2.052 2.052 0 0 0-.851.345.784.784 0 0 0 0 1.15 1.034 1.034 0 0 0 .688.209z",
    transform: "translate(-295.823 -169.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-3",
    d: "M336.921 194.174a2.14 2.14 0 0 1-1.464-.4 1.711 1.711 0 0 1-.446-1.3v-3.6h-.891v-1.261h.891v-1.9h1.459v1.9h1.357v1.261h-1.35v3.362a.617.617 0 0 0 .172.495 1.136 1.136 0 0 0 .693.147h.272s.192-.016.332-.031v1.248a5.656 5.656 0 0 1-1.025.079z",
    transform: "translate(-316.882 -163.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-3",
    d: "M355.1 182.94h.345a2.075 2.075 0 0 1 .272.013v1.3a1.322 1.322 0 0 0-.178-.013h-.265a.942.942 0 0 0-.7.223 1.014 1.014 0 0 0-.2.7v.307h1.326v1.261h-1.321v5.225h-1.484v-5.236H352v-1.26h.891v-.419a2.04 2.04 0 0 1 .568-1.56 2.3 2.3 0 0 1 1.644-.541z",
    transform: "translate(-330.778 -161.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-3",
    d: "M375.235 194.686a3 3 0 0 1 .617 1.058 4.314 4.314 0 0 1 0 2.656 2.97 2.97 0 0 1-.617 1.056 2.918 2.918 0 0 1-1.02.735 3.373 3.373 0 0 1-2.558 0 2.909 2.909 0 0 1-1.018-.735 2.97 2.97 0 0 1-.617-1.056 4.271 4.271 0 0 1 0-2.656 3 3 0 0 1 .617-1.058 2.876 2.876 0 0 1 1.018-.733 3.342 3.342 0 0 1 2.558 0 2.9 2.9 0 0 1 1.02.733zm-2.3.261a1.426 1.426 0 0 0-1.192.568 2.979 2.979 0 0 0 0 3.119 1.535 1.535 0 0 0 2.384 0 2.979 2.979 0 0 0 0-3.119 1.424 1.424 0 0 0-1.191-.569z",
    transform: "translate(-344.62 -169.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-3",
    d: "M405.8 194.089h.2l.223.02v1.482a2.673 2.673 0 0 0-.272-.031h-.272a1.635 1.635 0 0 0-1.2.446 1.6 1.6 0 0 0-.457 1.192v3.409h-1.482v-6.481h1.482v.965a1.669 1.669 0 0 1 .7-.729 2.121 2.121 0 0 1 1.078-.272z",
    transform: "translate(-370.058 -169.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-3",
    d: "M425.927 195.038a1.208 1.208 0 0 0-.916.394 1.441 1.441 0 0 0-.37 1.027v3.8h-1.481v-6.486h1.482v.693a2.157 2.157 0 0 1 .784-.613 2.39 2.39 0 0 1 1-.2 2.128 2.128 0 0 1 .994.223 1.9 1.9 0 0 1 .722.668 2.91 2.91 0 0 1 .934-.68 2.614 2.614 0 0 1 1.081-.223 2.086 2.086 0 0 1 1.593.642 2.371 2.371 0 0 1 .606 1.693v4.273h-1.482v-3.83a1.64 1.64 0 0 0-.279-1.032.969.969 0 0 0-.809-.352 1.208 1.208 0 0 0-.916.394 1.453 1.453 0 0 0-.37 1.027v3.8h-1.482v-3.841a1.64 1.64 0 0 0-.279-1.032.969.969 0 0 0-.809-.352z",
    transform: "translate(-386.083 -169.488)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTapLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tap-logo.664ab98a7e5a7ecf7e6fa38695ae4ca7.svg";